import { render, staticRenderFns } from "./zExpansionConfig.vue?vue&type=template&id=6a3cac00&scoped=true&"
import script from "./zExpansionConfig.vue?vue&type=script&setup=true&lang=js&"
export * from "./zExpansionConfig.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./zExpansionConfig.vue?vue&type=style&index=0&id=6a3cac00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3cac00",
  null
  
)

export default component.exports